/***********************************utils公共方法***************************************/
//是否是安卓环境
const isAndroid = () => {
  let u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
};
//是否是ios环境
const isIos = () => {
  let u = navigator.userAgent;
  let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let iphoneX = /iPhoneX/.test(u);
  return ios || iphoneX;
};
/**
 * 原生桥接公用方法,nativeName为原生方法名
 * @params value params为原生方法需要得参数集合
 */
const nativeFun = (nativeName, ...params) => {
  let [_android, _ios] = [isAndroid(), isIos()];
  try {
    //集团化和快保的原生方法调用
    if (_android) {
      KBYAndroid[nativeName](...params);
    } else if (_ios) {
      window.webkit.messageHandlers[nativeName].postMessage([...params]);
    }
  } catch (error) {
    console.log(`${nativeName}抛错了`, error);
  }
};
/**
 * 当有多个原生可调用的返回方法时，只需要返回其中一个触发的结果。
 * @params value list为多个返回函数的key
 * @params value callback为回调函数
 */
const getFirstCallback = (list, callback) => {
  if (!list || !list instanceof Array) return;
  let status = false;
  list.forEach(key => {
    window[key] = (...arg) => {
      if (!status && callback) {
        status = true;
        callback(...arg)
        setTimeout(() => {
          status = false;
        }, 0)
      }
    }
  })
}
/***********************************公共回调方法(防止系统原生对接报错)***************************************/
//初始化自定义原生方法
let appObj = {};
const init = (list) => {
  if (list && list instanceof Array) {
    list.forEach(key => {
      if (appObj[key]) window[key] = appObj[key];
    })
  } else {
    for (let key in appObj) {
      window[key] = appObj[key]
    }
  }
  appObj = {};
  //以下回调函数的挂载是为了防止原生的默认行为导致前端报错
  window.onWebResume = () => {}; //APP进入前台，回调方法
  window.onWebPause = () => {}; //APP进入后台，回调方法
  window.onWebReceiveNotice = (str) => {}; //app中webView的通讯接受监听方法,回调方法。str为接收webView的传值。它对应的回调方法是webPostNotice
}
//使用方法
/*
 * 1、在项目的main.js中引入init(["hiddenNavigationBar","setNativeBackFlag","listenBack",...]);//初始化需要引入的原生方法
 * 2、在页面中使用window.hiddenNavigationBar([1,2])、window.setNativeBackFlag([1],backFlag=>{})、window.listenBack(()=>{})
 */
/***********************************新旧包原生方法的合并***************************************/
/**
 * 通知app是否隐藏头部⽅法和武汉webveiw超时控制
 * @param value type1 隐藏头部参数：1：隐藏 2：显示
 * @param value type2 武汉webveiw超时控制：1 停止计时  2 清理缓存（没调方法，也清理）
 */
appObj.hiddenNavigationBar = ([type1, type2]) => {
  nativeFun("hiddenNavigationBar", type1);
}
/**
 * ⽩屏问题解决
 * @param value type 参数:1：h5⻚⾯加载完成 2：清理缓存
 */
appObj.loadingPageFinish = ([type]) => {
  console.log(type)
  nativeFun("loadingPageFinish", type);
}
/**
 * 设置物理返回标识
 * @param value type 参数：backFlag(0:默认值，原⽣⾃⼰处理; 1:交给web处理)
 * @return 如果backFlag传参为1，则回调函数触发
 */
appObj.setNativeBackFlag = ([backFlag], callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["leftButtonAction"], callback)
  nativeFun("setNativeBackFlag", backFlag);
}
/**
 * app的返回键的回调监听
 */
appObj.listenBack = (callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["nativeReturn", "leftButtonAction", "clickAndroidReturn"], callback)
}
/**
 * 打开新的webView
 * @param value url:⻚⾯链接
 * @param value type:(在集团化中是否第三⽅链接："yes"||"no"),(在老快包中“1”寿险（武汉有倒计时）、“3” 高端医疗（武汉有倒计时），“2”车险订单\短期险（北京无倒计时）)
 * @description 需要用户自己区分新包和老包
 */
appObj.openOutWebView = ([url, type]) => {
  //集团化的包和老快保的包
  nativeFun("openOutWebView", url, type);
}
/**
 * 关闭当前的webView
 */
appObj.backAction = () => {
  //集团化的包和老快保的包
  nativeFun("backAction");
}
/**
 * 关闭多个webView回到首页
 */
appObj.backRootAction = () => {
  //集团化的包和老快保的包
  nativeFun("backRootAction");
}
/**
 * 关闭所有web⽅法(root-->web1-->原⽣VC-->web2，调⽤finishAllWebAction后，只会留下root和原⽣VC，web所有⻚⾯被dealloc)
 */
appObj.finishAllWebAction = () => {
  //集团化的包和老快保的包
  nativeFun("finishAllWebAction");
}
/**
 * 打开新的webView,添加referer的web⻚⾯
 * @params 参数⼀：⻚⾯链接，参数⼆：是否第三⽅链接(yes 是 no否)，参数三：referer字符串
 */
appObj.openRefererWebView = ([url, type, referer]) => {
  nativeFun("openRefererWebView", url, type, referer);
}
/**
 * webView的通讯,发送方法，宁外回调函数window.onWebReceiveNotice需要接收页面手动添加
 * @params str为接收webView的传值
 */
appObj.webPostNotice = ([str]) => {
  nativeFun("webPostNotice", str);
}
/**
 * 禁⽌webview回弹效果
 * @params type为(0禁⽌回弹，1允许回弹)
 */
appObj.setWebviewNOBouncesAction = ([type]) => {
  nativeFun("setWebviewNOBouncesAction", type);
}
/**
 * H5获取本地userId和token，未登录时⾃动跳转登录⻚⾯
 * @params type：1代表获取userId，2代表获取token，3代表获取unionid
 * @return info为获取到的相应类型的字符串
 */
appObj.getUserMark = ([type], callback) => {
  //集团化的包和老快保的包
  //为兼容老版本，同时回调以下两个方法
  getFirstCallback(["loginSuccess", "loginNewSuccess"], callback)
  nativeFun("getUserMark", type);
}
/**
 * 获取用户信息,(原生app已登录的情况下)
 * @return info为⽤户信息JSON串 ,未登录时XX为 -1
 */
appObj.getUserInfo = (callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["invokeUserInfo"], callback)
  nativeFun("getUserInfo");
}
/**
 * h5⻚⾯登录成功后把⽤户信息传给APP
 * @params str：h5⻚⾯登录成功后返回的⽤户信息JSON串
 */
appObj.setUserInfo = ([str]) => {
  //集团化的包和老快保的包
  nativeFun("setUserInfo", str);
}
/**
 * 获取租户信息
 * @return info为⽤户信息
 */
appObj.getTenantInfo = (callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["setTenantInfo"], callback)
  nativeFun("getTenantInfo");
}
/**
 * 获取租户信息
 * @return info为租户信息
 */
appObj.getTenantInfo = (callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["setTenantInfo"], callback)
  nativeFun("getTenantInfo");
}
/**
 * ⽤户退出or注销
 */
appObj.logout = () => {
  //集团化的包和老快保的包
  nativeFun("logout");
}
/**
 * 去登录页面
 * 先退出注销，在获取token或userId，APP自动跳转登录
 */
appObj.toLogin = () => {
  nativeFun("logout");
  nativeFun("getUserMark", 1);
}

/**
 * 查看微信是否安装
 * @return state为(1为已安装，0为未安装)
 */
appObj.wxAppInstalled = (callback) => {
  //集团化的包和老快保的包
  getFirstCallback(["wxAppInstalledResult"], callback)
  nativeFun("wxAppInstalled");
}
/**
 * 调用微信登录⽅法
 * @return code为( 授权code码 或者 -1 )
 */
appObj.wxLoginAction = (callback) => {
  getFirstCallback(["wxLoginActionResult"], callback)
  nativeFun("wxLoginAction");
}

/**
 * ⾃定义分享页面⾯板操作(分享页面)
 webpageUrl:分享链接
 title:分享标题
 description:分享描述
 icon:分享图标链接 (全链接)
 */
appObj.sharePage = ([webpageUrl, title, description, icon], callback) => {
  nativeFun("sharePage", webpageUrl, title, description, icon);
}
/**
 * ⾃定义分享页面⾯板操作(不唤起分享⾯板的分享操作)
 * @param shareIconUrl     分享iconURL
 * @param shareTitle       分享title
 * @param shareDesc        分享描述
 * @param shareUrl         分享URL
 * @param sharePosterUrl   分享海报URL
 * @param shareType        传单个类型的一种 Wechat|WechatTimeline|QQFriend|DingDing|QZone|Mail|SMS|Copy|MyTeam|Poster
 * @param shareBase64Image 分享图片base64(参数为空：则为普通URL分享，参数不为空：则为分享图片)
 */
appObj.shareNoPage = ([shareIconUrl, shareTitle, shareDesc, shareUrl, sharePosterUrl, shareType = "Wechat|WechatTimeline|QQFriend|DingDing|QZone|Mail|SMS|Copy|MyTeam|Poster", shareBase64Image = ""], callback) => {
  getFirstCallback(["shareCallBack"], callback)
  nativeFun("shareNoPage", shareIconUrl, shareTitle, shareDesc, shareUrl, sharePosterUrl, shareType);
}
/**
 * ⾃定义分享图片⾯板操作(分享图⽚)
 * @params shareTypesTop 分享⾯板上部分分享类型(以|分割， Wechat | WechatTimeline | QQFriend | DingDing | QZone | Mail | SMS )
 * @params shareTypesBottom 分享面板下部分分享类型(以|分割)Copy|MyTeam|Poster
 * @params shareBase64Image 分享图⽚base64
 */
appObj.shareImage = ([shareTypesTop = "Wechat|WechatTimeline|QQFriend|DingDing|QZone|Mail|SMS", shareTypesBottom = "Copy|MyTeam|Poster", shareBase64Image = ""], callback) => {
  getFirstCallback(["shareCallBack"], callback)
  nativeFun("shareImage", shareTypesTop, shareTypesBottom, shareBase64Image);
}
/**
 * ⾃定义分享图片⾯板操作(不唤起分享⾯板的分享操作)
 * @params shareTypesTop 分享⾯板上部分分享类型(以|分割， Wechat | WechatTimeline | QQFriend | DingDing | QZone | Mail | SMS )
 * @params shareBase64Image 分享图⽚base64
 */
appObj.shareImageNoPage = ([shareTypesTop = "Wechat|WechatTimeline|QQFriend|DingDing|QZone|Mail|SMS", shareBase64Image = ""], callback) => {
  getFirstCallback(["shareCallBack"], callback)
  nativeFun("shareImageNoPage", shareTypesTop, shareBase64Image);
}
/**
 * 原生显示pdf
 * @parasm url pdf地址
 * @parasm title pdf的title
 * @parasm isShare 是否可以分享
 * @parasm desc 分享描述
 * @parasm pdfFileName 无用参数
 * @parasm pdfShareUrl 分享地址，如果有则分享此地址，没有分享pdf地址
 */
appObj.showPDF = ([url, title, isShare, desc, pdfFileName, pdfShareUrl]) => {
  nativeFun("showPDF", url, title, isShare, desc, pdfShareUrl);
}
/*
 * 保存图⽚到相册
 * @params 参数⼀base64Image：图⽚base64
 */
appObj.imageToAlbum = ([base64Image]) => {
  //集团化和老快包相同部分
  nativeFun("imageToAlbum", base64Image);
}
/**
 * 展示相机or相册
 * @params 参数⼀type：选择类型（1相机 2相册 3弹窗 4前置摄像头）
 */
appObj.showCamera = ([type], callback) => {
  getFirstCallback(["upLoadCameraImage"], callback)
  nativeFun("showCamera", type);
}
/**
 * 照⽚多选(打开相册)
 * @params 参数⼀num：选择图⽚的个数(最⼤为9个)
 */
appObj.selectPhoto = ([num], callback) => {
  getFirstCallback(["photoAlbumSelect"], callback)
  nativeFun("selectPhoto", num);
}

/**
 * 进⼊订单⾸⻚
 */
appObj.genUserOrder = () => {
  //集团化和老快包相同部分
  nativeFun("genUserOrder");
}

/**
 * 清理app缓存
 */
appObj.clearAppCacheSize = () => {
  //集团化和老快包相同部分
  nativeFun("clearAppCacheSize");
}

/**
 * 进⼊个⼈中⼼⻚⾯
 */
appObj.genUsc = () => {
  nativeFun("genUsc");
}
/**
 * 刷新个⼈中⼼
 */
appObj.refreshUserCenterView = () => {
  nativeFun("refreshUserCenterView");
}
/**
 * 进⼊⾸⻚
 */
appObj.genFirst = () => {
  nativeFun("genFirst");
}
/**
 * 刷新⾸⻚
 */
appObj.refreshFirstView = () => {
  nativeFun("refreshFirstView");
}
/**
 * 刷新用户信息
 */
appObj.appRefreshUserInfo = () => {
  nativeFun("appRefreshUserInfo");
}
/**
 * APP唤起微信小程序
 * @param username 拉起的小程序的username
 * @param location 拉起小程序页面的可带参路径，不填默认拉起小程序首页
 * @param version 拉起小程序的类型(0：正式版、1：开发板、2：体验版)
 */
appObj.launchMiniProgram = ([username, location, version]) => {
  //集团化和老快包相同部分
  nativeFun("launchMiniProgram", username, location, version);
}

/**
 * 复制到粘贴板
 * @params 参数⼀text：复制⽂字
 */
appObj.JSCopy = ([text]) => {
  //集团化和老快包相同部分
  nativeFun("JSCopy", text);
}


/**
 * 获取token
 */
appObj.getUserMarkNoLogin = ([type], callback) => {
  //集团化的包和老快保的包
  //为兼容老版本，同时回调以下两个方法
  getFirstCallback(["invokeUserMark"], callback)
  nativeFun("getUserMarkNoLogin", type);
}


/**
 *
 * @param payJson 支付参数(微信支付参数or支付宝支付参数or苹果支付JS串:{"productId":@"内购ID",@"orderId":""})
 */

appObj.payCallAPP = (payJson) => {
  nativeFun("payCallAPP", payJson);
}



export default appObj



// WEBPACK FOOTER //
// ./src/utils/tgjApp.js